import { v4 as uuid } from "uuid";
import { createSlice } from '@reduxjs/toolkit';
import { current } from '@reduxjs/toolkit'
import { NotificationModel } from "@/models/Notification";

export const initialState = {
  key: "",
  notifications: []
};

const NotificationReducer = createSlice({
  name: 'Notification',
  initialState,
  reducers: {
      add: (state, action) => {
          state.notifications.push(action.payload);
      },
      removeall: (state, action) => {
          state.notifications = [];
      },
      remove: (state, action) => {
          let messageObj = null;
          let j:number = 0;
        for(let i in state.notifications) {
            messageObj = state.notifications[i];
            if(messageObj?.key == action?.payload?.message?.key) {
              state.notifications.splice(j, 1);
              break;
            }
            j++;
        }
          
          //state.notifications.push(action.payload);
      },
      
  },
  extraReducers(builder) {
    builder.addMatcher(
      (action) => action.type.endsWith('fulfilled'),
      (state, action:Object) => {
          const payload = Object(action)?.payload;
          if(payload?.data?.notification) {
              state.notifications.push(payload.data.notification);
          } else if(payload?.data?.data?.notification) {
              state.notifications.push(payload?.data?.data?.notification);
          } else if(payload?.notification) {
              state.notifications.push(payload?.notification);
          }
//            if(action?.payload?.data?.data?.notification) {
//                state.notifications.push(action?.payload?.data?.data?.notification);
//            }

       });
       
    builder.addMatcher(
      (action) => (action.type == 'USER_LOGIN/fulfilled' || action.type == 'USER_LOGOUT/pending'),
      (state, action:Object) => {
       state.notifications = [];
       });

    builder.addMatcher(
      (action) => action.type.endsWith('rejected'),
      (state, action:Object) => {
          const payload = Object(action)?.payload;
          if(payload?.data?.notification) {
              state.notifications.push(payload.data.notification);
          } else if(payload?.data?.data?.notification) {
              state.notifications.push(payload?.data?.data?.notification);
          } else if(payload?.notification) {
              state.notifications.push(payload?.notification);
          }
//            if(action?.payload?.data?.data?.notification) {
//                state.notifications.push(action?.payload?.data?.data?.notification);
//            }

       });

       
    builder.addMatcher(
      (action) => action.type.endsWith('chat/receiveMessage'),
      (state, action) => {
          if(action["payload"]["event"]["data"]) {
          let item = JSON.parse(action["payload"]["event"]["data"]);
            if(item?.header != '' && item?.message != '' ) {
                state.notifications.push({secondsToClose:item?.secondsToClose, message: new NotificationModel("info", item.header, item.message, item?.secondsToClose) });
            }
            
          }
      })        
       
  }
});
 
export const {add,remove, removeall} = NotificationReducer.actions;
export default NotificationReducer.reducer;
